export default "/images/3543a412148f33d574829400c1723b3f.avif";